export default class Result<T = unknown> {
  // eslint-disable-next-line prettier/prettier
  public constructor(public readonly data: T, public readonly success: boolean = true) {}
}

export class EmptyResult extends Result<undefined> {
  public constructor() {
    super(undefined);
  }
}

export class HttpResult<T = unknown> extends Result<T> {
  public readonly headers: Record<string, string>;

  public constructor(
    public readonly data: T,
    headers: Headers = new Headers(),
    public readonly success: boolean = true,
  ) {
    super(data, success);
    this.headers = Object.fromEntries(headers.entries());
  }
}
